import moment from 'moment';
import store from '@/store';

class BindingConverters {

    public timeFormat(seconds: number) {
        return this.hhmmss(seconds);
    }

    public fromNow(date: Date) {
        return moment(date).fromNow();
    }

    public dateFormat(date: Date, format: string) {
        return moment(date).format(format);
    }

    // units = auto, major or minor
    public distanceFormat(metres: number, units: string = 'auto') {
        const m2km = 1.60934;
        const du = store.getters.preferences.distance;
        let r = '';
        let fix = 0;
        if (metres) {
            let val: number = metres;
            let u = 'm';
            switch (units) {
                case 'major':
                    val = (metres / 1000.0);
                    u = 'km';
                    break;
                case 'minor':
                    val = metres;
                    u = 'm';
                    break;
                case 'auto':
                default:
                    if (metres > 50000) {
                        val = (metres / 1000.0);
                        u = 'km';
                    } else if (metres > 5000) {
                        fix = 1;
                        val = (metres / 1000.0);
                        u = 'km';
                    }
            }
            let sval = val.toFixed(fix);
            if (du === 'miles' && u === 'km') {
                sval = (val / m2km).toFixed(fix);
                u = 'mls';
            }
            r = `${sval} <small><b>${u}</b></small>`;
        }
        return r;
    }

    public toTitleCase(val: string) {
        return val ? val.replace(/([A-Z]+)/g, ' $1').replace(/([A-Z][a-z])/g, ' $1') : '';
    }

    public speedFormat(val: number) {
        const mph = 2.23694;
        const kph = 3.6;
        let r = '';
        const u = 'm/s';
        if (val) {
            let sval = val;
            switch (store.getters.preferences.speed) {
                case 'mph':
                    sval = val * mph;
                    break;
                case 'kph':
                    sval = val * kph;
                    break;
            }
            r = `${sval.toFixed(1)} <small><b>${store.getters.preferences.speed}</b></small>`;
        }
        return r;
    }

    public elevationFormat(val: number, showArrow: boolean = false) {
        const f2m = 3.28084;
        let r = '';
        let u = 'm';
        if (val) {
            if (store.getters.preferences.elevation === 'feet') {
                val = val * f2m;
                u = 'ft';
            }
            const v = (showArrow ? Math.abs(val) : val).toFixed(0);
            let prefix = '';
            if (showArrow) {
                if (val > 0) {
                    prefix = '&#x2191;';
                } else if (val < 0) {
                    prefix = '&#x2193;';
                }
            }
            r = `${prefix}${v} <small><b>${u}</b></small>`;
        }
        return r;
    }

    private pad(num) {
        return ('0' + num).slice(-2);
    }

    private hhmmss(secs) {
        let minutes = Math.floor(secs / 60);
        secs = secs % 60;
        const hours = Math.floor(minutes / 60);
        minutes = minutes % 60;
        return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(secs)}`;
    }
}

const bc = new BindingConverters();

export default bc;
